import { ASSET_DESKTOP, ASSET_MOBILE } from '../elements/assets'

export const MEDIA_HIGHLIGHT = `
...on mediaHighlight_Entry {
  id
  typeHandle
  anchorId

  heading: headingAdvanced {
    html
  }

  ${ ASSET_MOBILE }
  ${ ASSET_DESKTOP }
}
`